export { ProfileTagsModule } from './profile-tags.module';
export * from './profile-tag-manager.service';
